import React, { useState } from "react";
import AdminDefaultLayout from "../AdminDefaultLayout";
import { useNavigate } from "react-router-dom";
import Packaging from "../Packaging";
import AnimalWelfare from "../AnimalWelfare";
import ClimateChange from "../ClimateChange";
import BreadCrumbs from "../BreadCrumbs";
import { COLUMNTITLES } from "../../../utils/Enum";
import ArchiveEnvironmentIndices from "./ArchiveEnvironmentIndices";
import ArchiveHumanRightsIndices from "./ArchiveHumanRightsIndices";
import AdminTabs from "../../../interfaces/AdminTabs";
import ErrorBoundary from "../../../components/ErrorBoundary";

const ArchiveDefault = () => {
  const [activeScoreTab, setActiveScoreTab] = useState(0);
  const adminTabs: AdminTabs[] = [
    { label: COLUMNTITLES.ENVIRONMENT, content: <ArchiveEnvironmentIndices /> },
    { label: COLUMNTITLES.HUMANRIGHTS, content: <ArchiveHumanRightsIndices /> },
    { label: COLUMNTITLES.PACKAGING, content: <Packaging />, disabled: true },
    {
      label: COLUMNTITLES.ANIMALWELFARE,
      content: <AnimalWelfare />,
      disabled: true,
    },
    {
      label: COLUMNTITLES.CLIMATECHANGE,
      content: <ClimateChange />,
      disabled: true,
    },
  ];

  const archiveTab = [
    { label: "Back to Admin Portal", content: <AdminDefaultLayout /> },
  ];
  const navigate = useNavigate();
  const handleBackToAdminPortalClick = () => {
    navigate("/admin", { replace: true });
  };
  const handleTabClick = (index: number, disabled?: boolean) => {
    if (!disabled) {
      setActiveScoreTab(index);
    }
  };

  return (
    <div className="flex flex-col">
      <div className="bg-gray-200 items-center justify-center">
        <BreadCrumbs breadcrumb={"Archived"} />
        <h1
          id="archiveTitle"
          className="m-2 text-blue text-center text-3xl font-medium leading-[40px] mb-[30px]"
        >
          {COLUMNTITLES.ARCHIVED}
        </h1>
        <div className="flex justify-between">
          <div className="flex mt-[8px] ml-[40px]">
            {adminTabs.map((tab, index) => (
              <button
                id={tab.label}
                key={index}
                className={`bg-none border-none cursor-pointer inline-flex mt-[8px] px-4 py-2 rounded-t-lg h-[40px] font-medium whitespace-nowrap transition-colors duration-200 ${
                  activeScoreTab == index
                    ? "bg-white/50 !important"
                    : "bg-gray-400 !important"
                }
                  ${tab.disabled ?? "bg-gray-400/25 text-opacity-50"}
                      `}
                onClick={() => handleTabClick(index, tab.disabled)}
              >
                {tab.label}
              </button>
            ))}
          </div>{" "}
          <button
            id={archiveTab[0].label}
            className={`float-right mr-[20px]  mb-[16px]  px-[16px] py-[6px] rounded-sm border-2 border-gray-400 
                text-gray-400 whitespace-nowrap text-[14px] font-medium leading-normal`}
            onClick={() => handleBackToAdminPortalClick()}
          >
            {archiveTab[0].label}
          </button>
        </div>
      </div>{" "}
      <main className="adminContent ">
        <div className="tabContent" id={adminTabs[activeScoreTab].label}>
          <ErrorBoundary>{adminTabs[activeScoreTab].content}</ErrorBoundary>
        </div>
      </main>
    </div>
  );
};

export default ArchiveDefault;
